export default class Permission {
    constructor({code = '', description = '', group = ''} = {}) {
        this.code = code;
        this.group = group;
        this.description = description;
    }
}
